"use client";
// init builder.io with your API key

import { builder } from "@builder.io/react";
builder.init(process.env.NEXT_PUBLIC_BUILDER_PUBLIC_API_KEY || "");

// register custom components
import "./custom-components-registry";
